import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const CATEGORIES = {
  SCHOLARSHIP: { id: 'scholarship', label: 'Scholarship', color: 'bg-blue-400', glow: 'shadow-blue-500/50' },
  TEACHER_TRAINING: { id: 'teacher_training', label: 'Teacher Training', color: 'bg-green-400', glow: 'shadow-green-500/50' },
  MENTORSHIP: { id: 'mentorship', label: 'Mentorship', color: 'bg-purple-400', glow: 'shadow-purple-500/50' },
};

export const generateId = () => Math.random().toString(36).substr(2, 9);